// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a9f86cd4","949":"509cda8b"}[chunkId] + ".chunk.js";
};